// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportCard_root__2LGkj"};